<template>
  <div>
    <!-- 待出票，非秒出单，近10分钟未催票过，才能发起催票 -->
    <span
      v-if="row.orderStatus == 3 && row.orderType != 3 && !row.remindLog"
      @click="onOpen"
      class="table-link"
    >
      催出票
    </span>
    <el-dialog
      title="催出票"
      :visible.sync="dialogVisible"
      modal-append-to-body
      append-to-body
      destroy-on-close
      width="30%"
    >
      <div class="status-tip color-pink">
        <template>
          <div><i class="el-icon-info"></i>确认催出票？</div>
          <div>每个订单10分钟内只能发起一次催出票</div>
        </template>
      </div>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="warning" @click="onSure" :loading="saveLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mini from "@/api/mini";
const MiniModel = new mini();
export default {
  props: {
    row: {
      type: Object, // 行数据
      default: () => {},
    },
    isOrder: {
      // 是否是订单信息
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      detail: {}, // 详情信息
      detailLoading: false, // 详情的loading
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框
    };
  },

  methods: {
    // 批量操作
    onOpen() {
      this.dialogVisible = true;
      this.getDetail();
    },

    // 请求列表
    async getDetail() {
      this.detailLoading = true;
      const params = {
        orderId: this.row.orderId,
      };
      const res = await MiniModel.getOrderDetail(params).finally(() => {
        this.detailLoading = false;
      });
      if (res.data.code === 200) {
        this.detail = res.data.data || {};
      }
    },
    // 确定
    async onSure() {
      const res = await MiniModel.pushOut({
        appKey: localStorage.getItem("appKeyMini"),
        orderUUID: this.row.orderUUID,
      });
      if (res.data.code == 200) {
        this.$message.success("催出票成功！");
        this.onCancel();
        this.$emit("refresh");
      } else {
        this.$message.error(res.data.message);
      }
    },
    // 取消
    onCancel() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.status {
  &-tip {
    line-height: 30px;
  }
}
.el-icon-info {
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/groupOrder/PushTicket.vue